import React from 'react';
import DocumentTitle from 'react-document-title';
import TopNavBar from './nav/TopNavBar';

import SubNavBar from './nav/SubNavBar';
import SettingsContainer from './settings/SettingsContainer';

const SettingsPage = () => {
  return (
    <DocumentTitle title='Sparkler - Settings'>
      <div>
        <TopNavBar />
        <SubNavBar />
        <div className='row'>
          <div className='column small-12 medium-6 large-5'>
            <SettingsContainer />
          </div>
        </div>
      </div>
    </DocumentTitle>
  );
}

export default SettingsPage;
